<h1 mat-dialog-title>An Error Occurred!</h1>
<div mat-dialog-content>
  <p class="mat-body-1">{{ data?.message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Okay</button>
</div>
